import { supa } from '../components/firebase';
import { useEffect, useState } from 'react';
import { Search, OpenInWindow, Plus, User, Box, Calendar, StatsUpSquare } from 'iconoir-react';
import ModalUser from '../components/modalUser';
import ModalPacchetto from '../components/modalPacchetto';
import ModalPersonalTrainer from '../components/modalPersonalTrainer';
import ModalInfoUser from '../components/modalInfoUser';
import ModalInfoPersonalTrainer from '../components/modalInfoPersonalTrainer';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthProvider';
import ActivityIndicator from '../components/activityIndicator';

function Home() {
  const { user } = useAuth();
  const navigate = useNavigate()
  const [modalAdd, setModalAdd] = useState(false)
  const [modalAddPacchetto, setModalAddPacchetto] = useState(false)
  const [modalAddPersonalTrainer, setModalAddPersonalTrainer] = useState(false)

  const [loading, setLoading] = useState(false)

  const [modalInfoUser, setModalInfoUser] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [modalInfoPersonalTrainer, setModalInfoPersonalTrainer] = useState(false)
  const [selectedPersonalTrainer, setSelectedPersonalTrainer] = useState(null)

  const [usentiAttivi, setUtentiAttivi] = useState(0)
  const [utentiInScadenza, setUtentiInScadenza] = useState(0)

  const [users, setUsers] = useState([])
  const [pacchetti, setPacchetti] = useState([])
  const [personalTrainers, setPersonalTrainers] = useState([])
  const [search, setSearch] = useState('')

  async function getUtenti() {
    setLoading(true)
    const { data, error } = await supa
      .from('utenti')
      .select('*')
    if (error) console.log(error); setLoading(false)
      data.sort((a, b) => a.nome.localeCompare(b.nome) || a.cognome.localeCompare(b.cognome))
      setUsers(data)
      setLoading(false)
  }

  async function getPacchetti() {
    setLoading(true)
    const { data, error } = await supa
      .from('pacchetti')
      .select('*')
    if (error) console.log(error); setLoading(false)
    setPacchetti(data)
    setLoading(false)
  }

  async function getPersonalTrainers() {
    setLoading(true)
    const { data, error } = await supa
      .from('personalTrainer')
      .select('*')
    if (error) console.log(error); setLoading(false)
    setPersonalTrainers(data?.sort((a, b) => a.nome.localeCompare(b.nome) || a.cognome.localeCompare(b.cognome)))
    setLoading(false)
  }

  async function personalInScadenza() {
    setLoading(true)
    const { data, error } = await supa
      .from('pacchettiAcquistati')
      .select('*')
    if (error) console.log(error); setLoading(false)
      setUtentiAttivi(data.filter((item) => new Date(item.fine) >= new Date()).length)
      setUtentiInScadenza(data.filter((item) =>  (new Date(item.fine) >= new Date() && new Date(item.fine) < new Date(new Date().getTime() + 10 * 24 * 60 * 60 * 1000))).length)
      setLoading(false)
  }

  console.log(usentiAttivi)

  useEffect(() => {
    getUtenti()
    getPacchetti()
    getPersonalTrainers()
    personalInScadenza()
  }, [])

  const openModalInfoUser = (user) => {
    setSelectedUser(user)
    setModalInfoUser(true)
  }

  const openModalInfoPersonalTrainer = (personalTrainer) => {
    setSelectedPersonalTrainer(personalTrainer)
    setModalInfoPersonalTrainer(true)
  }

  console.log(users.length)

  const filteredUsers = users?.filter((item) => 
    item?.nome?.toLowerCase()?.includes(search?.toLowerCase()) || 
    item?.cognome?.toLowerCase()?.includes(search?.toLowerCase())
  )

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-50 to-zinc-100">
      {loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <ActivityIndicator />
        </div>
      ) : (
        <>
          {/* Modals */}
          {modalAdd && <ModalUser visible={modalAdd} setVisible={setModalAdd} aggiorna={getUtenti} />}
          {modalAddPacchetto && <ModalPacchetto visible={modalAddPacchetto} setVisible={setModalAddPacchetto} aggiorna={getPacchetti} />}
          {modalAddPersonalTrainer && <ModalPersonalTrainer visible={modalAddPersonalTrainer} setVisible={setModalAddPersonalTrainer} aggiorna={getPersonalTrainers} />}
          {modalInfoUser && <ModalInfoUser visible={modalInfoUser} setVisible={setModalInfoUser} utente={selectedUser} aggiorna={getUtenti} />}
          {selectedPersonalTrainer && modalInfoPersonalTrainer && <ModalInfoPersonalTrainer visible={modalInfoPersonalTrainer} setVisible={setModalInfoPersonalTrainer} personalTrainer={selectedPersonalTrainer} aggiorna={getPersonalTrainers} />}

          <div className="w-full px-4 sm:px-6 lg:px-8 py-8 space-y-8">
            
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h1 className="text-3xl sm:text-4xl font-bold text-zinc-900">Dashboard</h1>
                <p className="mt-1 text-sm text-zinc-600">Panoramica generale della tua palestra</p>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Pacchetti Attivi Card */}
              <div className="group relative bg-white rounded-2xl shadow-sm border border-zinc-200 p-6 hover:shadow-lg hover:border-green-200 transition-all duration-300 overflow-hidden">
                {/* Subtle gradient background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-emerald-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="flex items-center justify-between mb-5">
                    <div className="p-3 bg-green-100 rounded-xl group-hover:bg-green-200 group-hover:scale-110 transition-all duration-300">
                      <Box className="w-6 h-6 text-green-600" strokeWidth={2} />
                    </div>
                    <span className="text-xs font-semibold text-green-700 bg-green-100 px-3 py-1.5 rounded-full">Attivi</span>
                  </div>
                  <div className="mt-4">
                    <h3 className="text-3xl font-bold text-zinc-900 mb-1">{usentiAttivi}</h3>
                    <p className="text-sm text-zinc-600">Pacchetti attivi</p>
                  </div>
                </div>
              </div>

              {/* Pacchetti in Scadenza Card */}
              <div className="group relative bg-white rounded-2xl shadow-sm border border-zinc-200 p-6 hover:shadow-lg hover:border-orange-200 transition-all duration-300 overflow-hidden">
                {/* Subtle gradient background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-orange-50 to-amber-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="flex items-center justify-between mb-5">
                    <div className="p-3 bg-orange-100 rounded-xl group-hover:bg-orange-200 group-hover:scale-110 transition-all duration-300">
                      <Calendar className="w-6 h-6 text-orange-600" strokeWidth={2} />
                    </div>
                    <span className="text-xs font-semibold text-orange-700 bg-orange-100 px-3 py-1.5 rounded-full">Urgenti</span>
                  </div>
                  <div className="mt-4">
                    <h3 className="text-3xl font-bold text-zinc-900 mb-1">{utentiInScadenza}</h3>
                    <p className="text-sm text-zinc-600">Scadono entro 10 giorni</p>
                  </div>
                </div>
              </div>

              {/* Total Users Card */}
              <div className="group relative bg-white rounded-2xl shadow-sm border border-zinc-200 p-6 hover:shadow-lg hover:border-blue-200 transition-all duration-300 overflow-hidden">
                {/* Subtle gradient background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-cyan-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="flex items-center justify-between mb-5">
                    <div className="p-3 bg-blue-100 rounded-xl group-hover:bg-blue-200 group-hover:scale-110 transition-all duration-300">
                      <User className="w-6 h-6 text-blue-600" strokeWidth={2} />
                    </div>
                    <span className="text-xs font-semibold text-blue-700 bg-blue-100 px-3 py-1.5 rounded-full">Totale</span>
                  </div>
                  <div className="mt-4">
                    <h3 className="text-3xl font-bold text-zinc-900 mb-1">{users.length}</h3>
                    <p className="text-sm text-zinc-600">Utenti registrati</p>
                  </div>
                </div>
              </div>

              {/* Personal Trainers Card */}
              <div className="group relative bg-white rounded-2xl shadow-sm border border-zinc-200 p-6 hover:shadow-lg hover:border-purple-200 transition-all duration-300 overflow-hidden">
                {/* Subtle gradient background on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-purple-50 to-fuchsia-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10">
                  <div className="flex items-center justify-between mb-5">
                    <div className="p-3 bg-purple-100 rounded-xl group-hover:bg-purple-200 group-hover:scale-110 transition-all duration-300">
                      <StatsUpSquare className="w-6 h-6 text-purple-600" strokeWidth={2} />
                    </div>
                    <span className="text-xs font-semibold text-purple-700 bg-purple-100 px-3 py-1.5 rounded-full">Team</span>
                  </div>
                  <div className="mt-4">
                    <h3 className="text-3xl font-bold text-zinc-900 mb-1">{personalTrainers.length}</h3>
                    <p className="text-sm text-zinc-600">Personal Trainers</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Grid - Compact sections */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              
              {/* Personal Trainers Section - Compact */}
              <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden hover:shadow-md transition-shadow">
                <div className="px-6 py-4 bg-white border-b border-zinc-200 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="p-2 bg-purple-100 rounded-lg">
                      <StatsUpSquare className="w-4 h-4 text-purple-600" />
                    </div>
                    <h2 className="text-base font-semibold text-zinc-900">Personal Trainers</h2>
                  </div>
                  <button 
                    onClick={() => setModalAddPersonalTrainer(true)} 
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-medium rounded-lg text-xs shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                    aria-label="Aggiungi personal trainer"
                  >
                    <Plus className="w-3.5 h-3.5" />
                    <span>Aggiungi</span>
                  </button>
                </div>
                <div className="overflow-y-auto max-h-64 scrollbar-thin scrollbar-thumb-zinc-300 scrollbar-track-zinc-100">
                  <div className="divide-y divide-zinc-100">
                    {personalTrainers?.length > 0 ? (
                      personalTrainers.map((item, index) => (
                        <div 
                          key={index} 
                          className="px-6 py-3 hover:bg-zinc-50 transition-colors flex items-center justify-between group"
                        >
                          <div className="flex items-center gap-3 flex-1">
                            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center text-purple-700 font-semibold text-sm">
                              {item?.nome?.charAt(0)}{item?.cognome?.charAt(0)}
                            </div>
                            <div>
                              <p className="text-sm font-medium text-zinc-900">{item?.nome} {item?.cognome}</p>
                            </div>
                          </div>
                          <button
                            onClick={() => openModalInfoPersonalTrainer(item)}
                            className="p-2 hover:bg-purple-50 rounded-lg transition-all opacity-0 group-hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-purple-400"
                            aria-label={`Visualizza dettagli ${item?.nome} ${item?.cognome}`}
                          >
                            <OpenInWindow className="w-4 h-4 text-purple-600" />
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="px-6 py-8 text-center text-sm text-zinc-500">
                        Nessun trainer disponibile
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Pacchetti Section - Compact */}
              <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden hover:shadow-md transition-shadow">
                <div className="px-6 py-4 bg-white border-b border-zinc-200 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="p-2 bg-yellow-100 rounded-lg">
                      <Box className="w-4 h-4 text-yellow-600" />
                    </div>
                    <h2 className="text-base font-semibold text-zinc-900">Pacchetti</h2>
                  </div>
                  <button 
                    onClick={() => setModalAddPacchetto(true)} 
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-medium rounded-lg text-xs shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                    aria-label="Aggiungi pacchetto"
                  >
                    <Plus className="w-3.5 h-3.5" />
                    <span>Aggiungi</span>
                  </button>
                </div>
                <div className="overflow-y-auto max-h-64 scrollbar-thin scrollbar-thumb-zinc-300 scrollbar-track-zinc-100">
                  <div className="divide-y divide-zinc-100">
                    {pacchetti?.length > 0 ? (
                      pacchetti.map((item, index) => (
                        <div 
                          key={index} 
                          className="px-6 py-3 hover:bg-zinc-50 transition-colors flex items-center justify-between"
                        >
                          <div className="flex items-center gap-3 flex-1">
                            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-yellow-100 to-yellow-200 flex items-center justify-center">
                              <Box className="w-5 h-5 text-yellow-700" />
                            </div>
                            <div className="flex-1">
                              <p className="text-sm font-semibold text-zinc-900">{item?.nome}</p>
                              <p className="text-xs text-zinc-500">{item?.num_lezioni} lezioni</p>
                            </div>
                          </div>
                          <div className="text-right">
                            <p className="text-sm font-bold text-zinc-900">€ {item?.prezzo}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="px-6 py-8 text-center text-sm text-zinc-500">
                        Nessun pacchetto disponibile
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Users Section */}
            <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 overflow-hidden hover:shadow-md transition-shadow">
              <div className="px-6 py-5 bg-white border-b border-zinc-200">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <User className="w-5 h-5 text-blue-600" />
                    </div>
                    <div>
                      <h2 className="text-lg font-semibold text-zinc-900">Lista Utenti</h2>
                      <p className="text-xs text-zinc-600 mt-0.5">Gestisci i tuoi clienti</p>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Search className="h-4 w-4 text-zinc-400" />
                      </div>
                      <input
                        type="text"
                        placeholder="Cerca utente..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="pl-9 pr-4 py-2 w-full sm:w-64 bg-white border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-all shadow-sm"
                        aria-label="Cerca utente per nome o cognome"
                      />
                    </div>
                    <button 
                      onClick={() => setModalAdd(true)} 
                      className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-zinc-900 font-semibold rounded-xl text-sm shadow-sm hover:shadow transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400"
                      aria-label="Aggiungi utente"
                    >
                      <Plus className="w-4 h-4" />
                      <span>Aggiungi Utente</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-zinc-50 border-b border-zinc-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Nome</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Cognome</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider hidden md:table-cell">Data di nascita</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider hidden lg:table-cell">Note</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider hidden sm:table-cell">Aggiunto il</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Stato</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold text-zinc-700 uppercase tracking-wider">Azioni</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-zinc-100">
                    {filteredUsers?.length > 0 ? (
                      filteredUsers.map((item, index) => (
                        <tr key={index} className="hover:bg-blue-50/30 transition-all duration-150 group">
                          <td className="px-6 py-4">
                            <div className="flex items-center gap-3">
                              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-blue-700 font-semibold text-sm">
                                {item?.nome?.charAt(0)}{item?.cognome?.charAt(0)}
                              </div>
                              <span className="text-sm font-semibold text-zinc-900">{item?.nome}</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-sm font-medium text-zinc-900">{item?.cognome}</td>
                          <td className="px-6 py-4 text-sm text-zinc-600 hidden md:table-cell">
                            {item?.birth ? new Date(item?.birth).toLocaleDateString('it-IT') : "-"}
                          </td>
                          <td className="px-6 py-4 text-sm text-zinc-600 hidden lg:table-cell max-w-xs truncate">
                            {item?.note || "-"}
                          </td>
                          <td className="px-6 py-4 text-sm text-zinc-600 hidden sm:table-cell">
                            {item?.created_at ? new Date(item?.created_at).toLocaleDateString('it-IT') : "-"}
                          </td>
                          <td className="px-6 py-4">
                            <span 
                              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${
                                item?.quota != null && new Date(item?.quota) > new Date()
                                  ? 'bg-green-100 text-green-700 ring-1 ring-green-200'
                                  : 'bg-red-100 text-red-700 ring-1 ring-red-200'
                              }`}
                              aria-label={item?.quota != null && new Date(item?.quota) > new Date() ? 'Quota attiva' : 'Quota scaduta'}
                            >
                              {item?.quota != null && new Date(item?.quota) > new Date() ? '● Attiva' : '● Scaduta'}
                            </span>
                          </td>
                          <td className="px-6 py-4">
                            <button
                              onClick={() => navigate(`/profiloUtente/${item.id}`)}
                              className="p-2 hover:bg-blue-100 rounded-lg transition-all opacity-70 group-hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
                              aria-label={`Visualizza profilo ${item?.nome} ${item?.cognome}`}
                            >
                              <OpenInWindow className="w-5 h-5 text-blue-600" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="px-6 py-16 text-center">
                          <div className="flex flex-col items-center justify-center">
                            <div className="w-16 h-16 rounded-full bg-zinc-100 flex items-center justify-center mb-4">
                              <User className="w-8 h-8 text-zinc-400" />
                            </div>
                            <p className="text-base font-semibold text-zinc-900">Nessun utente trovato</p>
                            <p className="text-sm text-zinc-500 mt-2">
                              {search ? 'Prova con un altro termine di ricerca' : 'Inizia aggiungendo il primo utente'}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Home;
